
export const addSectionAction = function (item, form) {
    return {
        type: "FB_ADD_SECTION",
        payload: item,
        form
    }
};

export const setSectionsAction = function (items, form) {
    return {
        type: "FB_SET_SECTIONS",
        payload: items,
        form
    }
};

export const removeSectionAction = function (item, form) {
    return {
        type: "FB_REMOVE_SECTION",
        payload: item,
        form
    }
};

export const clearSectionsAction = function () {
    return {
        type: "FB_CLEAR_SECTIONS"
    }
};


export const changeSectionAction = function (item, form) {
    return {
        type: "FB_CHANGE_SECTION",
        payload: item,
        form
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form-builder/sections.js